export default "__VITE_ASSET__d20be09c__"